<template>
  <div class="page">
    <side-icons />
    <section v-if="isPc" class="section flex flex-y-center no-padding-bottom">
      <el-image class="avatar" :src="avatar" fit="cover" />
      <div class="userinfo">
        <h3 class="fs-32 margin-bottom-20px">Short Bio & Research Interests</h3>
        <p class="text margin-bottom-10px">Dr. Tieyong Zeng is a Professor at the Department of Mathematics, The Chinese University of Hong Kong (CUHK). Together with colleagues, he has founded the Center for Mathematical Artificial Intelligence (CMAI) since 2020 and served as the director of CMAI. He received the B.S. degree from Peking University, Beijing, China, the M.S. degree from Ecole Polytechnique, Palaiseau, France, and the Ph.D. degree from the University of Paris XIII, Paris, France, in 2000, 2004, and 2007, respectively.</p>
        <p class="text">His research interests include image processing, optimization, artificial intelligence, scientific computing, computer vision, machine learning, and inverse problems. He has published around 100 papers in the prestigious journals such as SIAM Journal on Imaging Sciences, SIAM Journal on Scientific Computing, Journal of Scientific Computing, IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI), International Journal of Computer Vision (IJCV), IEEE Transactions on Neural Networks and Learning Systems (TNNLS), IEEE Transactions on Image Processing (TIP), IEEE Medical Imaging (TMI), and Pattern Recognition.</p>
      </div>
    </section>
    <section v-else class="section no-padding-bottom">
      <div class="flex flex-evenly flex-y-center">
        <el-image class="avatar" :src="avatar" fit="cover" />
        <div class="text-center intro-title">
          <p class="fs-36 bold">Short Bio</p>
          <p class="fs-36 bold margin-top-10px margin-bottom-10px">&</p>
          <p class="fs-36 bold">Research Interests</p>
        </div>
      </div>
      <div class="margin-top-20px userinfo">
        <p class="text margin-bottom-20px">Dr. Tieyong Zeng is a Professor at the Department of Mathematics, The Chinese University of Hong Kong (CUHK). Together with colleagues, he has founded the Center for Mathematical Artificial Intelligence (CMAI) since 2020 and served as the director of CMAI. He received the B.S. degree from Peking University, Beijing, China, the M.S. degree from Ecole Polytechnique, Palaiseau, France, and the Ph.D. degree from the University of Paris XIII, Paris, France, in 2000, 2004, and 2007, respectively.</p>
        <p class="text">His research interests include image processing, optimization, artificial intelligence, scientific computing, computer vision, machine learning, and inverse problems. He has published around 100 papers in the prestigious journals such as SIAM Journal on Imaging Sciences, SIAM Journal on Scientific Computing, Journal of Scientific Computing, IEEE Transactions on Pattern Analysis and Machine Intelligence (TPAMI), International Journal of Computer Vision (IJCV), IEEE Transactions on Neural Networks and Learning Systems (TNNLS), IEEE Transactions on Image Processing (TIP), IEEE Medical Imaging (TMI), and Pattern Recognition.</p>
      </div>
    </section>
    <section class="section no-padding-bottom">
      <div class="text-center"><h3 class="fs-36 text-decoration section-title">Work Experiences</h3></div>
      <div class="padding-left-50px padding-right-50px timeline">
        <el-timeline>
          <el-timeline-item timestamp="2021-Present" placement="top">
            <el-card>
              <h4 class="text-main fs-20">Professor (tenured)</h4>
              <p class="margin-top-10px">The Chinese University of Hong Kong, Hong Kong</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2020-Present" placement="top">
            <el-card>
              <h4 class="text-main fs-20">Director</h4>
              <p class="margin-top-10px">Center for Mathematical Artificial Intelligence, The Chinese University of Hong Kong</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2018-2021" placement="top">
            <el-card>
              <h4 class="text-main fs-20">Associate Professor (tenured)</h4>
              <p class="margin-top-10px">The Chinese University of Hong Kong, Hong Kong</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2015-2018" placement="top">
            <el-card>
              <h4 class="text-main fs-20">Associate Professor (tenured)</h4>
              <p class="margin-top-10px">Hong Kong Baptist University, Hong Kong</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2008-2015" placement="top">
            <el-card>
              <h4 class="text-main fs-20">Assistant Professor</h4>
              <p class="margin-top-10px">Hong Kong Baptist University, Hong Kong</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2007-2008" placement="top">
            <el-card>
              <h4 class="text-main fs-20">Post-doc Researcher</h4>
              <p class="margin-top-10px">CMLA, École Normale Supérieure, Cachan, France</p>
            </el-card>
          </el-timeline-item>
          <el-timeline-item timestamp="2004-2007" placement="top">
            <el-card>
              <h4 class="text-main fs-20">Research Engineer</h4>
              <p class="margin-top-10px">CNRS (Centre National de la Recherche Scientifique), France</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <!-- <el-image :src="img" fit="contain" /> -->
      </div>
    </section>
    <section class="section contact-section">
      <div class="text-center"><h3 class="fs-36 text-decoration section-title">Contact Me</h3></div>
      <div class="flex-1 flex flex-x-center flex-y-center">
        <i class="iconfont icon-dingwei" />
        <p class="fs-18">The Chinese University of Hong Kong, Room 225, Lady Shaw Building, CUHK, Shatin, N.T., Hong Kong.</p>
      </div>
      <div class="flex flex-x-center flex-y-center email-etc">
        <p class="margin-top-20px margin-bottom-20px">
          <i class="iconfont icon-email" />
          <span class="fs-18">zeng@math.cuhk.edu.hk</span>
        </p>
        <p class="links margin-left-40px">
          <i class="el-icon-link" />
          <el-link :href="url[0]" :underline="false" target="_blank">Google Scholar</el-link>
          <el-divider direction="vertical" />
          <el-link :href="url[1]" :underline="false" target="_blank">Researchgate</el-link>
        </p>
      </div>
    </section>
  </div>
</template>
<script type="text/javascript">
import SideIcons from '@/components/sideIcons/sideIcons'
export default {
  components: { SideIcons },
  data() {
    return {
      avatar: require('../../assets/imgs/avatar.jpeg'),
      img: require('../../assets/imgs/about_1.png'),
      img2: require('../../assets/imgs/about_2.png'),
      url: [
        'https://scholar.google.com.hk/citations?user=2yyTgRwAAAAJ&hl=zh-CN',
        'https://www.researchgate.net/profile/Tieyong-Zeng'
      ]
    }
  },
  computed: {
    isPc() {
      return this.device === 'pc'
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.page {
  .section{
    padding-left: 10%;
    padding-right: 10%;
    .section-title{
      margin-bottom: 30px;
    }
    li{
      margin-bottom: 10px;
    }
    .iconfont,
    .el-icon-link{
      font-size: 24px;
      line-height: 16px;
      margin-right: 10px;
      vertical-align: middle;
    }
    .links{
      .el-link{
        font-size: 18px;
      }
    }
    /deep/ .el-timeline-item__timestamp{
      font-size: 14px;
    }
  }
  .avatar{
    width: 250px;
    height: 320px;
    min-width: 250px;
    border-radius: 20px;
    margin-right: 50px;
  }
  .contact-section{
    padding-top: 30px;
  }
  .userinfo .text{
    text-align: justify;
  }
  .el-divider--vertical{
    margin: 0 20px;
  }
}
@media screen and (max-width: 760px){
  .avatar{
    width: 40vw !important;
    height: 52vw !important;
    min-width: 40vw !important;
    margin-right: 0 !important;
  }
  .userinfo .text{
    font-size: 18px;
  }
  .contact-section{
    .email-etc{
      flex-direction: column;
      align-items: flex-start;
    }
    .links{
      margin-left: 0;
    }
  }
  .intro-title{
    font-family: Harmony-Rgular;
  }
  .timeline{
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
</style>
